import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-user-circle",
  "use": "foquz-icon-user-circle-usage",
  "viewBox": "0 0 18 19",
  "content": "<symbol viewBox=\"0 0 18 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-user-circle\"><path d=\"M14 15.5v-.6c0-.636-.263-1.247-.732-1.697A2.554 2.554 0 0011.5 12.5h-5c-.663 0-1.299.253-1.768.703A2.352 2.352 0 004 14.9v.6m13-6a8 8 0 11-16 0 8 8 0 0116 0zm-6-2a2 2 0 11-4 0 2 2 0 014 0z\" stroke=\"#3F65F1\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol